import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.VUE_APP_HTTP_BASE_URL,
  timeout: 30 * 1000,
  headers: {}
})

instance.interceptors.request.use(config => {
  return config
}, error => {
  console.error(error)
})

instance.interceptors.response.use(response => {
  return response.data
}, error => {
  console.error(error)
})

export default instance
